import { render, staticRenderFns } from "./yulanSt.vue?vue&type=template&id=39786063&scoped=true"
import script from "./yulanSt.vue?vue&type=script&lang=js"
export * from "./yulanSt.vue?vue&type=script&lang=js"
import style0 from "./yulanSt.vue?vue&type=style&index=0&id=39786063&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39786063",
  null
  
)

export default component.exports